import axios from 'axios';

export const PROXY_BASE_URL = `/asp_net/proxy.aspx`;
export const MFA_LB = 'lb://mfaintegration';
export const AUTH_LB = 'lb://AuthenticationService';
export const MFA_BASE_URL = `${PROXY_BASE_URL}?${MFA_LB}`;
export const AUTH_BASE_URL = `${PROXY_BASE_URL}?${AUTH_LB}`;

export interface ResponseHeader {
  header?: {resultStatus?: string; resultMessage?: string; resultCode?: string};
}

const api = axios.create();

export default api;
